var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { SVGIcon, SVGIconGroup, SVGIconPath } from '../../components/SVGIcon';
var TimeSeparatorIconShape = React.createElement(SVGIconGroup, null, React.createElement(SVGIconPath, {
  d: "M11.8461538,14.3076923 C13.970326,14.3076923 15.6923077,16.029674 15.6923077,18.1538462 C15.6923077,20.2780183 13.970326,22 11.8461538,22 C9.72198173,22 8,20.2780183 8,18.1538462 C8,16.029674 9.72198173,14.3076923 11.8461538,14.3076923 Z M11.8461538,2 C13.970326,2 15.6923077,3.72198173 15.6923077,5.84615385 C15.6923077,7.97032596 13.970326,9.69230769 11.8461538,9.69230769 C9.72198173,9.69230769 8,7.97032596 8,5.84615385 C8,3.72198173 9.72198173,2 11.8461538,2 Z"
}));
export var TimeSeparatorIcon = function TimeSeparatorIcon(props) {
  var className = props.className,
      restProps = __rest(props, ["className"]);

  return React.createElement(SVGIcon, Object.assign({}, restProps, {
    className: "TimeSeparatorIcon ".concat(className || '')
  }), TimeSeparatorIconShape);
};